import { render } from "./TrackingPedido.vue?vue&type=template&id=08da9c4e"
import script from "./TrackingPedido.vue?vue&type=script&lang=js"
export * from "./TrackingPedido.vue?vue&type=script&lang=js"

import "./TrackingPedido.vue?vue&type=style&index=0&id=08da9c4e&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__